import {Component, output} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {debounceTime} from 'rxjs';
import moment from 'moment';

@Component({
  selector: 'tgrid-year-selector',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
],
  templateUrl: './year-selector.component.html',
  standalone: true,
  styleUrl: './year-selector.component.scss',
})
export class YearSelectorComponent {
  private readonly FIRST_YEAR_OF_DATA = 2013;
  private readonly LAST_YEAR_OF_DATA = moment().year();

  public valueChange = output<number[]>();

  protected possibleYears: number[] = [];
  protected filterControl = new FormControl<number[]>([], {nonNullable: true});

  constructor() {
    for (let year = this.FIRST_YEAR_OF_DATA; year <= this.LAST_YEAR_OF_DATA; year++) {
      this.possibleYears.push(year);
    }


    this.filterControl.valueChanges
      .pipe(
        debounceTime(100),
        takeUntilDestroyed(),
      )
      .subscribe(value => {
        this.valueChange.emit(value);
      });

    this.filterControl.setValue(this.possibleYears);
  }

}
